Wee.fn.make('landingPage2', {
	init: function() {
		var scope = this;

		$.events.on({
			'ref:showVideo': {
				click: function() {
					scope.showVideo();
				}
			},
			'ref:hideVideo': {
				click: function() {
					scope.hideVideo();
				}
			},
			'ref:video': {
				click: function() {
					scope.hideVideo();
				}
			},
			'ref:arrow': {
				click: function() {
					Wee.animate.tween('body', {
						scrollTop: $('ref:submission').offset().top
					}, {
					    duration: 300
					});
				}
			}
		}, {
			namespace: 'landingPage2'
		});
	},
	showVideo: function() {
		$('ref:video').show();
		$('ref:youtube').attr('src', 'https://www.youtube.com/embed/' + $.get('youtubeVideoId') + '?rel=0');

		// Dynamically initlaize youtube analytics through GTM on modal open
		if ($._win._initYouTubeAnalytics && typeof $._win._initYouTubeAnalytics == 'function') {
			$._win._initYouTubeAnalytics();
		}

	},
	hideVideo: function() {
		$('ref:video').hide();
		$('ref:youtube').attr('src', '');
	},
	unload: function() {
		$.events.off(null, '.landingPage2');
	},
});
